<template>
  <svg
    v-if="!props.active"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6381 18.6383H6.54629C4.70854 18.6383 3.21875 17.1485 3.21875 15.3107V8.65566C3.21875 6.81791 4.70854 5.32812 6.54629 5.32812H17.6381C19.4758 5.32812 20.9656 6.81791 20.9656 8.65566V15.3107C20.9656 17.1485 19.4758 18.6383 17.6381 18.6383Z"
      stroke="#333333"
      stroke-width="1.66377" />
    <path d="M6.5459 9.21094H9.87344" stroke="#4D4D4D" stroke-width="1.66377" />
  </svg>
  <svg
    v-else
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3913_10603)">
      <path
        d="M17.6381 18.6363H6.54629C4.70854 18.6363 3.21875 17.1465 3.21875 15.3088V8.65371C3.21875 6.81596 4.70854 5.32617 6.54629 5.32617H17.6381C19.4758 5.32617 20.9656 6.81596 20.9656 8.65371V15.3088C20.9656 17.1465 19.4758 18.6363 17.6381 18.6363Z"
        fill="url(#paint0_linear_3913_10603)"
        stroke="url(#paint1_linear_3913_10603)"
        stroke-width="1.66377" />
      <path d="M6.5459 9.20898H9.87344" stroke="white" stroke-width="1.66377" />
      <g filter="url(#filter0_d_3913_10603)">
        <circle cx="20.3184" cy="20.7461" r="1" fill="white" />
      </g>
      <g filter="url(#filter1_d_3913_10603)">
        <path
          d="M0.999802 19.3492C0.999802 19.7416 1.31792 20.0598 1.71035 20.0598C2.10278 20.0598 2.4209 19.7416 2.4209 19.3492C2.4209 18.9568 2.10278 18.6387 1.71035 18.6387C1.31792 18.6387 0.999802 18.9568 0.999802 19.3492Z"
          fill="white" />
        <path
          d="M1.66406 19.3496C1.66427 19.3746 1.68495 19.3953 1.70996 19.3955C1.72267 19.3955 1.73486 19.3902 1.74316 19.3818L1.75586 19.3496C1.75586 19.3243 1.73528 19.3037 1.70996 19.3037L1.67773 19.3164C1.66938 19.3247 1.66406 19.3369 1.66406 19.3496Z"
          stroke="white"
          stroke-width="1.51279" />
      </g>
      <g filter="url(#filter2_d_3913_10603)">
        <path
          d="M15.4197 2.71055C15.4197 3.10297 15.7378 3.4211 16.1303 3.4211C16.5227 3.4211 16.8408 3.10297 16.8408 2.71055C16.8408 2.31812 16.5227 2 16.1303 2C15.7378 2 15.4197 2.31812 15.4197 2.71055Z"
          fill="white" />
        <path
          d="M16.084 2.71094C16.0842 2.73595 16.1049 2.75663 16.1299 2.75684C16.1426 2.75684 16.1548 2.75152 16.1631 2.74316L16.1758 2.71094C16.1758 2.68562 16.1552 2.66504 16.1299 2.66504L16.0977 2.67773C16.0893 2.68604 16.084 2.69823 16.084 2.71094Z"
          stroke="white"
          stroke-width="1.51279" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_3913_10603"
        x="17.3184"
        y="17.7461"
        width="6"
        height="6"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3913_10603" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3913_10603"
          result="shape" />
      </filter>
      <filter
        id="filter1_d_3913_10603"
        x="-0.03"
        y="17.6087"
        width="3.4809"
        height="3.48187"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="0.515" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3913_10603" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3913_10603"
          result="shape" />
      </filter>
      <filter
        id="filter2_d_3913_10603"
        x="13.3899"
        y="-0.03"
        width="5.4809"
        height="5.48187"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="1.015" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3913_10603" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3913_10603"
          result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_3913_10603"
        x1="9.72594"
        y1="9.57528"
        x2="-0.480601"
        y2="19.5208"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#8F42FF" stop-opacity="0" />
        <stop offset="1" stop-color="#8F42FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3913_10603"
        x1="22.1488"
        y1="20.8889"
        x2="6.95547"
        y2="0.242084"
        gradientUnits="userSpaceOnUse">
        <stop />
        <stop offset="0.193154" stop-color="#46207D" />
        <stop offset="0.603514" stop-color="#8F42FE" />
        <stop offset="0.875923" stop-color="#C7A1FF" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <clipPath id="clip0_3913_10603">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  active: {
    type: Boolean,
    default: false,
  },
});
</script>
